import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from "react-router-dom";

import { HOST } from "../../store/types";

import GetCards from "../../components/GetCards/GetCards";
import { Container } from "../../components/Container/Container";
import HeaderPage from "../../components/HeaderPage/HeaderPage";
import Filter from "../../components/Filter/Filter";

import { ContainerCatalogStyled } from "../../components/Container/style";

import i18n from "i18next";
import { useDispatch, useSelector } from 'react-redux'
import { switchViewInCatalogAction } from '../../store/switchView/actions'

import { ContainerCatalogSt } from './style';

const getSlug = (pathname) => pathname.substr(pathname.lastIndexOf('/',) + 1);

const Channel = () => {
    // скрываем основной контент страницы и показываем результаты фильтрации
    const [hiddenContentPage, setHiddenContentPage] = useState(false);
    const [contentPage, setContentPage] = useState([]);
    const [channel, setChannel] = useState(false);
    const [adr, setAdr] = useState("productions");

    const dispatch = useDispatch();
    const switchView = useSelector((store) => store.switchViewInCatalog.switchViewInCatalog);
    const location = useLocation();

    const isMounted = useRef(true);
    useEffect(() => () => { isMounted.current = false }, []);

    //Получаем содержимое страницы
    const _onContentPage = useCallback((slug) => {
        fetch(`${HOST}/v1/channels`)
            .then(res => {
                return res.json();
            })
            .then(body => {
                if (isMounted.current) setChannel(body.data);
                return body.data;
            })
            .then((channels) => {
                // считаем по свежим данным, а не по состоянию, которое ещё не применилось
                const testChannel = channels.reduce((sum, item) => {
                    return item.slug === slug ? sum + 1 : sum;
                }, 0);
                return testChannel ? "channels" : "productions";
            })
            .then((nextAdr) => {
                if (isMounted.current) setAdr(nextAdr);

                return fetch(`${HOST}/v1/${nextAdr}/${slug}`)
                    .then(res => {
                        return res.json();
                    })
                    .then(body => {
                        if (isMounted.current) setContentPage(body.data);
                    });
            });
    }, []);

    // componentDidMount + componentDidUpdate: загрузка при монтировании и при переходе на другой канал
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            _onContentPage(getSlug(location.pathname).toLowerCase());
            dispatch(switchViewInCatalogAction(false));
            return;
        }

        //переход на другой проект
        dispatch(switchViewInCatalogAction(false));
        setContentPage([]);
        _onContentPage(getSlug(location.pathname));
    }, [location.pathname, _onContentPage, dispatch]);

    // скрываем основной контент страницы и показываем результаты фильтрации
    const _hiddenContentPage = useCallback((x) => {
        setHiddenContentPage(x);
    }, []);

    let logoIMg = "";
    (i18n.language === 'en') ? logoIMg = contentPage.image_en : logoIMg = contentPage.image_ru
    if (logoIMg === "") {
        logoIMg = (i18n.language === 'en') ? '/images/default-top-img-en.png' : '/images/default-top-img-ru.png'
    }

    return (
        <>
            <HeaderPage
                Title={i18n.t(`channel.about_the_channel`)}
                Leftdiv={contentPage.description}
                Rightdiv={logoIMg}
                Rightvideo={contentPage.video_embed} />
            <ContainerCatalogStyled>
                <Filter _hiddenContentPage={_hiddenContentPage} />
                <Container>
                    <div style={!hiddenContentPage ? { height: "auto", overflow: "" } : { height: "0", overflow: "hidden" }}>
                        {(adr === "channels" && channel)
                            // если каналы
                            &&
                            <>
                                <div style={!switchView ? { height: "auto", overflow: "" } : { height: "0", overflow: "hidden" }}>
                                    {contentPage.id && <GetCards sourceCards={`channels/${+contentPage.id}/projects`} type="catalog" cardDisplayType="carousel" getChannelContent={[0]} />}
                                    {contentPage.id && <GetCards sourceCards={`channels/${+contentPage.id}/projects`} type="catalog" cardDisplayType="carousel" getChannelContent={[1]} />}
                                    {contentPage.id && <GetCards sourceCards={`channels/${+contentPage.id}/projects`} type="catalog" cardDisplayType="carousel" getChannelContent={[2]} />}
                                </div>
                                {switchView && <ContainerCatalogSt>
                                    <GetCards
                                        sourceCards={`projects?sort[column][]=year_start&sort[column][]=title.ru&sort[order][]=desc&sort[order][]=asc&filter%5Bchannel_id%5D=${contentPage.id}`}
                                        type="catalog"
                                        cardDisplayType="grid"
                                        tile={true}
                                    />
                                </ContainerCatalogSt>}
                            </>
                        }
                        {(adr === "productions" && channel)
                            // если продакшн
                            &&
                            <>
                                <div style={!switchView ? { height: "auto", overflow: "" } : { height: "0", overflow: "hidden" }}>
                                    {contentPage.id && <GetCards sourceCards={`productions/${+contentPage.id}/projects`} type="catalog" cardDisplayType="carousel" getChannelContent={[0]} />}
                                    {contentPage.id && <GetCards sourceCards={`productions/${+contentPage.id}/projects`} type="catalog" cardDisplayType="carousel" getChannelContent={[1]} />}
                                    {contentPage.id && <GetCards sourceCards={`productions/${+contentPage.id}/projects`} type="catalog" cardDisplayType="carousel" getChannelContent={[2]} />}
                                </div>
                                {switchView && <ContainerCatalogSt>
                                    <GetCards
                                        sourceCards={`projects?sort[column][]=year_start&sort[column][]=title.ru&sort[order][]=desc&sort[order][]=asc&filter%5Bproduction_id%5D=${contentPage.id}`}
                                        type="catalog"
                                        cardDisplayType="grid"
                                        tile={true}
                                    />
                                </ContainerCatalogSt>}
                            </>
                        }
                    </div>
                </Container>
            </ContainerCatalogStyled>
        </>
    )
};

export default Channel;
